export default function getTranslationsFromDomElements() {
  const nodes = document.querySelectorAll<HTMLElement>('[id^="react-container"]');

  const mergedTranslations: Record<string, unknown> = {};

  nodes.forEach((node) => {
    const jsonTranslations = node.getAttribute('data-translations') ?? undefined;
    if (jsonTranslations) {
      try {
        const translations: unknown = JSON.parse(jsonTranslations);
        Object.assign(mergedTranslations, translations);
      } catch {
        console.warn(`Could not parse translations for ${node.id}`);
      }
    }
  });

  return mergedTranslations;
}
